export interface IUserProps {
  id: string
  uuid: string
  username: string
  lastName: string
  firstName: string
}

export default class UserEntity {
  private _props: IUserProps

  constructor(props: IUserProps) {
    this._props = props
  }

  get props(): IUserProps {
    return this._props
  }

  get id(): string {
    return this._props.id
  }

  get username(): string {
    return this._props.username
  }

  get name(): string {
    return this._props.lastName + this._props.firstName
  }

  get lastName(): string {
    return this._props.lastName
  }

  get firstName(): string {
    return this._props.firstName
  }
}

export const EmptyUserPropsFactory = (props?: Partial<IUserProps>): IUserProps => ({
  id: '',
  uuid: '',
  username: '',
  lastName: '',
  firstName: '',
  ...props
})
